import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '../components/Login'
import MerLogin from '../components/MerLogin'
import Home from '../components/home'
import Welcome from '../components/Welcome'
import Users from '../components/user/Users'
import Rights from '../components/power/Rights'
import Roles from '../components/power/Roles'
import Cate from '../components/goods/Cate'
import Params from '../components/goods/Params'
import Goods from '../components/goods/Goods'
import Addgood from '../components/goods/Addgood'
import Order from '../components/order/Order'
import Report from '../components/report/Report'
import MerChant from '../components/merchant/MerChant'
import QrCode from '../components/coupon/QrCode'
import AutoQr from '../components/coupon/AutoQr'
import ChangePassword from '../components/merchant/ChangePassword'
import AddParkCard from '../components/parkcard/AddParkCard'
import ImpParkCard from '../components/parkcard/ImpParkCard'
import Reconciliation from '../components/parkcard/Reconciliation'
import ApplyCoupon from '../components/coupon/ApplyCoupon'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/merlogin' },
  { path: '/login', component: MerLogin },
  { path: '/merlogin', component: MerLogin },
  { path: '/autoQr', component: AutoQr },
  { path: '/applycoupon/:couponId/:couponMoney/:parkName/:merchantId/:parkCode', component: ApplyCoupon },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },
      { path: '/merchant', component: MerChant },
      { path: '/changepassword', component: ChangePassword },
      { path: '/qrcode', component: QrCode },
      { path: '/users', component: Users },
      { path: '/rights', component: Rights },
      { path: '/roles', component: Roles },
      { path: '/categories', component: Cate },
      { path: '/params', component: Params },
      { path: '/goods', component: Goods },
      { path: '/goods/add', component: Addgood },
      { path: '/orders', component: Order },
      { path: '/reports', component: Report },
      { path: '/addparkcard', component: AddParkCard },
      { path: '/impparkcard', component: ImpParkCard },
      { path: '/reconciliation', component: Reconciliation }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/', // 生产环境打包使用
  routes
})

// 挂载路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path.startsWith('/applycoupon')) {
    return next()
  } else {
    // 获取token
    const tokenStr = window.sessionStorage.getItem('token')
    if (!tokenStr) return next('/login')
    next()
  }
})

export default router
